import { Component } from "@angular/core";
import { FieldType } from "@ngx-formly/core";

@Component({
  selector: "coi-checklist-checkbox-type",
  template: `

  <div class="row mb-5">
    <div class="ml-3 mr-0" style="margin: auto;">
    
        <div [ngClass]="{
        'form-check': props.formCheck.indexOf('custom') === -1,
        'form-check-inline': props.formCheck === 'inline',
        'custom-control custom-checkbox': props.formCheck.indexOf('custom') === 0,
        'custom-control-inline': props.formCheck === 'custom-inline'
        }">
            <input type="checkbox"
                #checkboxEl
                [class.is-invalid]="showError"
                [class.form-check-input]="props.formCheck.indexOf('custom') === -1"
                [class.custom-control-input]="props.formCheck.indexOf('custom') === 0"
                [indeterminate]="props.indeterminate && formControl.value === null"
                [formControl]="formControl"
                [id]="elementId"
                [formlyAttributes]="field">
                <label [for]="elementId"
                [class.form-check-label]="props.formCheck.indexOf('custom') === -1"
                [class.custom-control-label]="props.formCheck.indexOf('custom') === 0"
            >
                {{ props.label }}
                <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
            </label>
        </div>

    </div>
    <div class="col">
        {{props.data.label | translate}}
    </div>
  </div>
 `,
})
export class CoiChecklistCheckBoxTypeComponent extends FieldType {
  defaultOptions = {
    templateOptions: {
      options: [],
      formCheck: 'custom-inline', // 'custom' | 'custom-inline' | 'stacked' | 'inline'
    },
  };

  isData(option) {
    return option.data;
  }

  get elementId(): string {
    if (this.field.id && this.field.id.includes('formly_')) {
      let prefix = this.form['id'];

      // check if in repeat section
      if (!prefix && this.field.parent.parent && this.field.parent.parent.parent && this.field.parent.parent.parent.type === 'repeat') {
        const cnt = this.field.parent.parent.key;
        prefix = `${this.field.parent.parent.parent['id']}_${cnt}`;
      }

      return `${prefix ? prefix + '_' : ''}${(this.key as string).replace('.', '_')}`;
    } else {
      return this.field.id;
    }
  }
}
